<!--
 * @Author: lbb lhz6887@163.com
 * @Date: 2024-07-03 10:52:07
 * @LastEditors: lbb lhz6887@163.com
 * @LastEditTime: 2024-07-22 11:29:31
 * @FilePath: \YHB_H5\src\pages\oneClickRegister\components\step.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="step-box">
    <div class="step-content">
      <div class="step-title">商户基本信息</div>
      <van-form ref="paramsForm" label-width="60px" :show-error="false" error-message-align="right" validate-first>
        <van-field v-model="params.merchName" clearable name="商户名称" label="商户名称" placeholder="请输入商户名称"
          :rules="rule.merchName" />
        <van-field name="商户性质" label="商户性质" placeholder="请选择商户性质" :rules="rule.merchType">
          <template #input>
            <div class="" style="width: 100%">
              <van-radio-group v-model="params.merchType" direction="horizontal" checked-color="#d32537">
                <van-radio :name="item.id" v-for="item in natureMerchant" :key="item.id" :disabled="item.disabled">
                  {{ item.name }}
                  <template #icon="props">
                    <img class="img-icon" :src="props.checked ? item.checked : item.unchecked"
                      style="width: 20px; height: 20px" />
                  </template>
                </van-radio>
              </van-radio-group>
              <div class="tips">
                若您的商户有营业执照，请在对应电签app内进件。
              </div>
            </div>
          </template>
        </van-field>
        <van-field readonly :rules="rule.province" clickable name="省市区" :value="cityAddress" label="商户地址"
          placeholder="请选择省市区" right-icon="arrow" @click="cityShow = true" />
        <van-field clearable :rules="rule.address" type="textarea" v-model="params.address" name="详细地址" autosize
          :rows="1" label="详细地址" @click-right-icon.stop="getMap" right-icon="location-o" placeholder="只填写街道/门牌号即可" />
      </van-form>
    </div>

    <Footer @giveup="giveup" @confirm="confirm" :step="0" />

    <van-popup v-model="cityShow" position="bottom">
      <van-picker show-toolbar :columns="cityList" value-key="name" @confirm="cityConfirm" @cancel="cityShow = false" />
    </van-popup>
  </div>
</template>

<script>
import { merchBase, getWsLocationIP, getWsLocationAddress } from "@/api/index";
import { Toast } from "vant";
import Footer from "./footer.vue";

export default {
  name: "Step01",
  components: {
    Footer,
  },
  props: {
    merchartInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    cityList: [],
  },
  watch: {
    merchartInfo: {
      immediate: false,
      deep: true,
      handler(val) {
        Object.keys(this.params).forEach((key) => {
          this.params[key] = val[key];
        });
      },
    },
  },
  computed: {
    cityAddress() {
      return (
        this.params.province + this.params.city + this.params.district || ""
      );
    },
  },
  data() {
    return {
      params: {
        merchName: "", // 商户名称
        merchType: "", // 商户性质
        province: "", // 省
        provinceCode: "", // 省 code
        city: "", // 市
        cityCode: "", // 市 code
        district: "", // 区
        districtCode: "", // 区 code
        address: "", // 详细地址
        longitude: "", //	经度,
        latitude: "", // 	纬度
        registerId: "", // 进件 ID
      },
      natureMerchant: [
        {
          id: 1,
          name: "小微",
          disabled: false,
          checked:
            "https://yhb-pub.oss-cn-shenzhen.aliyuncs.com/YHB_H5/checked-01.png",
          unchecked:
            "https://yhb-pub.oss-cn-shenzhen.aliyuncs.com/YHB_H5/unchecked-01.png",
        },
        {
          id: 2,
          name: "个体",
          disabled: true,
          checked:
            "https://yhb-pub.oss-cn-shenzhen.aliyuncs.com/YHB_H5/checked-01.png",
          unchecked:
            "https://yhb-pub.oss-cn-shenzhen.aliyuncs.com/YHB_H5/unchecked-01.png",
        },
        {
          id: 3,
          name: "企业",
          disabled: true,
          checked:
            "https://yhb-pub.oss-cn-shenzhen.aliyuncs.com/YHB_H5/checked-01.png",
          unchecked:
            "https://yhb-pub.oss-cn-shenzhen.aliyuncs.com/YHB_H5/unchecked-01.png",
        },
      ],
      rule: {
        merchName: [{ required: true, message: "请输入商户名称" }],
        merchType: [{ required: true, message: "请选择商户性质" }],
        province: [{ required: true, message: "请选择商户地址" }],
        address: [{ required: true, message: "请输入详细地址" }],
      },
      // 上市选择 弹窗
      cityShow: false,
      // cityList: []

      // 定位是否成功
      positionFlag: false,
    };
  },
  created() {
    var that = this;
    // 获取经纬度并赋值

    window.initMap = function () {
      try {
        var geolocation = new qq.maps.Geolocation(
          "KXFBZ-MQWCQ-MHC5Y-4UAHR-AALTF-2JB22"
        );
        geolocation.getLocation(
          function success(position) {
            if (!position.province || !position.city) {
              this.getLocation();
            }
            self.positionFlag = true;
            self.params.province = position.province;
            self.params.city = position.city;
            self.params.district = position.district;
            self.params.longitude = position.lng; //	经度
            self.params.latitude = position.lat; // 	纬度
            self.params.provinceCode = position.adcode.substring(0, 2) + "0000";
            self.params.cityCode = position.adcode.substring(0, 4) + "00";
            self.params.districtCode = position.adcode;
          },
          function error() {
            that.getLocation();
          },
          {
            timeout: 15000, // 默认值为10s;
            failTipFlag: true,
          }
        );
      } catch {
        that.getLocation();
      }
    };
    // this.getLocation();
    // 定位，此方式必须是https
    this.loadMap();

    this.$nextTick(() => {
      Object.keys(this.params).forEach((key) => {
        this.params[key] = this.merchartInfo[key] || "";
      });

      this.params.merchType = 1;

      setTimeout(() => {
        this.params.registerId = this.merchartInfo.id;
      }, 300);
    });
  },
  methods: {
    getMap() {
      window.initMap();
    },
    loadMap() {
      var url =
        "https://apis.map.qq.com/tools/geolocation/min?key=KXFBZ-MQWCQ-MHC5Y-4UAHR-AALTF-2JB22&referer=location&callback=initMap"; // 成功回调为initMap方法
      var jsapi = document.createElement("script");
      jsapi.charset = "utf-8";
      jsapi.src = url;
      document.head.appendChild(jsapi);
    },
    // 定位
    getLocation() {
      Toast.loading({
        message: "定位中...",
        forbidClick: true,
        duration: "toast",
      });
      const self = this;

      getWsLocationIP()
        .then((res) => {
          console.log("定位成功", res.result.ad_info);
          Toast.clear();
          if (res.status === 0) {
            const data = res.result.ad_info;
            const location = res.result.location;
            const adcode = data.adcode + "";
            self.positionFlag = true;
            self.params.province = data.province;
            self.params.city = data.city;
            self.params.district = data.district;
            self.params.longitude = location.lng; //	经度
            self.params.latitude = location.lat; // 	纬度
            self.params.provinceCode = adcode.substring(0, 2) + "0000";
            self.params.cityCode = adcode.substring(0, 4) + "00";
            self.params.districtCode = adcode;
          }
        })
        .catch(() => {
          self.positionFlag = false;
          console.log("定位失败");
        });

      //   const mapObj = new AMap.Map("iCenter");
      //   mapObj.plugin("AMap.Geolocation", function () {
      //     var geolocation = new AMap.Geolocation({
      //       // 是否使用高精度定位，默认：true
      //       enableHighAccuracy: true,
      //       // 设置定位超时时间，默认：无穷大
      //       timeout: 10000,
      //       needAddress: true,
      //     });

      //     geolocation.getCurrentPosition();
      //     AMap.event.addListener(geolocation, "complete", onComplete);
      //     AMap.event.addListener(geolocation, "error", onError);

      //     function onComplete(data) {
      //       // data是具体的定位信息
      //       console.log("定位成功信息：", data);
      //       self.positionFlag = true;
      //       // self.params.province = data.addressComponent.province
      //       // self.params.city = data.addressComponent.city
      //       // self.params.district = data.addressComponent.district
      //       // self.params.cityCode = data.addressComponent.citycode
      //       // self.params.districtCode = data.addressComponent.adcode
      //       self.params.longitude = data.position.lng; //	经度
      //       self.params.latitude = data.position.lat; // 	纬度
      //       self.params.address =
      //         data.addressComponent.township +
      //         data.addressComponent.street +
      //         data.addressComponent.streetNumber;
      //       Toast.clear();
      //     }

      //     function onError(data) {
      //       // self.getLongitudeLatitude()
      //       Toast.clear();
      //       self.positionFlag = false;
      //       // 定位出错
      //       console.log("定位失败错误：", data);
      //       if (data.message == "Geolocation permission denied.") {
      //         // 用户拒绝授权
      //         Toast("定位失败，请前往设置开启定位权限后，点击定位图标");
      //         return;
      //       } else {
      //         Toast("定位失败，请前往设置开启定位权限，点击定位图标");
      //       }
      //       // 调用ip定位
      //       self.getLngLatLocation();
      //     }
      //   });

      // getLngLatLocation() {
      //   let self = this;
      //   AMap.plugin("AMap.CitySearch", () => {
      //     var citySearch = new AMap.CitySearch();
      //     citySearch.getLocalCity((status, result) => {
      //       if (status === "complete" && result.info === "OK") {
      //         // 查询成功，result即为当前所在城市信息
      //         console.log("通过ip获取当前城市：", result);
      //         const code = result.rectangle.split(";");
      //         this.getRestapi(code[1]);
      //         // self.params.longitude = result.position.lng //	经度
      //         // self.params.latitude = result.position.lat // 	纬度
      //       }
      //     });
      //   });
      // },

      // 调用 高德 api 获取省市区code
      // getRestapi(code) {
      //   console.log("经纬度", code);
      //   const key = "";
      //   const v = "113.526966,22.240935";
      //   axios({
      //     method: "GET",
      //     url: `https://restapi.amap.com/v3/geocode/regeo?key=d8fc4a17654589865cc4f9fbd57e1c41&location=${code}&radius=1000&extensions=all`,
      //   }).then((res) => {
      //     console.log("getRestapi", res.data);
      //   });
    },

    cityConfirm(picker, value) {
      this.params.province = picker[0];
      this.params.provinceCode = this.cityList[value[0]].code;
      this.params.city = picker[1];
      this.params.cityCode = this.cityList[value[0]].children[value[1]].code;
      this.params.district = picker[2];
      this.params.districtCode =
        this.cityList[value[0]].children[value[1]].children[value[2]].code;
      this.cityShow = false;
    },

    // 根据位置获取经纬度
    // getLongitudeLatitude() {
    //   // //restapi.amap.com/v3/geocode/geo?key=您的key&address=广东省珠海市香洲区前山街道兰埔路298号心海州&city=珠海
    //   const address =
    //     this.params.province +
    //     this.params.city +
    //     this.params.district +
    //     this.params.address;
    //   return axios({
    //     method: "GET",
    //     url: `https://restapi.amap.com/v3/geocode/geo?key=d8fc4a17654589865cc4f9fbd57e1c41&address=${address}&radius=1000&city=${this.params.city}`,
    //   });
    // },

    // 下一步
    async confirm() {
      // 触发表单的校验
      await this.$refs.paramsForm
        .validate()
        .then(async () => {
          Toast.loading({
            message: "提交中...",
            forbidClick: true,
            duration: "toast",
          });
          // 定位失败 需要根据选择的省市区获取经纬度
          if (
            !this.positionFlag &&
            this.params.province &&
            this.params.city &&
            this.params.district &&
            this.params.address
          ) {
            const res = await getWsLocationAddress(
              this.params.province +
              this.params.city +
              this.params.district +
              this.params.address
            );
            console.log(res);
            if (res.code !== 200) return Toast("地址解析失败！");
            this.params.longitude = res.data.longitude;
            this.params.latitude = res.data.latitude;
            // const res = await this.getLongitudeLatitude();
            // const str = res.data.geocodes[0].location;
            // this.params.longitude = str.split(",")[0];
            // this.params.latitude = str.split(",")[1];
          }

          // 校验表单是否有为空的内容
          if (!this.objIsNull(this.params, ["provinceCode"])) {
            Toast("请完整填写表单！");
            return;
          }

          // 请求基本信息的接口
          merchBase(this.params).then((res) => {
            if (res.code != 200) {
              Toast.clear();
              Toast(res.msg);
              return;
            }
            this.$emit("confirm", { data: res.data, step: 0 });
          });
        })
        .catch((e) => {
          console.log(e);
          Toast(e[0].message);
          return;
        });
    },
    // 放弃注册
    giveup() {
      this.$emit("giveup");
    },
  }
};
</script>

<style scoped lang="scss">
::v-deep .van-cell {
  padding: 15px 5px;

  .van-field__control {
    text-align: right;
  }

  .van-radio-group {
    margin-right: -10px;
    justify-content: flex-end;
  }

  .van-field__control {
    .tips {
      width: 100%;
      font-size: 10px;
      color: #d32537;
    }
  }
}

::van-radio-group .van-radio-group {
  text-align: right;
}
</style>
